var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      staticClass: "modal-validate",
      attrs: {
        name: _vm.modalName,
        "show-close": false,
        "cover-closeable": false,
        "close-btn-handler": _vm.handleClose
      },
      on: { modalClose: _vm.handleClose }
    },
    [
      _c(
        "div",
        {
          staticClass: "content auto_scale",
          attrs: { slot: "modal-content" },
          slot: "modal-content"
        },
        [
          _c("div", {
            staticClass: "close-right",
            on: { click: _vm.handleClose }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "title_text",
            domProps: {
              innerHTML: _vm._s(_vm.mainData.award_popup_title || "领取优惠")
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "input_content-wrap" }, [
            _c("div", { staticClass: "line_wrap" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.telNum,
                    expression: "telNum"
                  }
                ],
                staticClass: "tel input",
                attrs: {
                  type: "tel",
                  placeholder: "请输入手机号",
                  maxlength: 11,
                  id: "inputPhone"
                },
                domProps: { value: _vm.telNum },
                on: {
                  focus: function($event) {
                    return _vm.setViewArea("phone")
                  },
                  blur: _vm.temporaryRepair,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.telNum = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "line_wrap vali_wrap" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.validNum,
                    expression: "validNum"
                  }
                ],
                staticClass: "vali_num input",
                attrs: {
                  type: "number",
                  placeholder: "手机验证码",
                  id: "inputCode"
                },
                domProps: { value: _vm.validNum },
                on: {
                  focus: function($event) {
                    return _vm.setViewArea("code")
                  },
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.validNum = $event.target.value
                    },
                    _vm.handleInputLength
                  ],
                  blur: _vm.temporaryRepair
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "vali_btn",
                  class: { disable: !_vm.telStatus || !_vm.validBtnStatus },
                  on: { click: _vm.getValidNum }
                },
                [
                  _vm._v(_vm._s(_vm.validBtnText)),
                  _vm.validBtnText !== "获取验证码"
                    ? _c("span", [_vm._v("s")])
                    : _vm._e()
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "confirm_btn",
            class: { disable: !_vm.validStatus || !this.telStatus },
            domProps: {
              innerHTML: _vm._s(
                _vm.mainData.award_popup_button_desc || "点击领取"
              )
            },
            on: { click: _vm.handleGetVoucher }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }